var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footerblock"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.appname))]),_c('a',{attrs:{"href":_vm.website}},[_vm._v(" ООО \"ЦиК АлеКоН\"")]),_vm._v(" Версия "+_vm._s(_vm.version)+"\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d483af7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/appfooter.vue
// module id = tMET
// module chunks = 1